<template>
  <div id="aiOptimizeWriterDialog" class="aiWriter aiOptimizeWriterDialog" v-show="showContent">
    <div class="aiWriter-content" @copy="handleCopy2">
      <div class="head">
        <div class="l">
          <div class="icon"></div>
          <div class="title">优化</div>
        </div>
        <div class="r">
          <div @click="toggleShowContent(false)" class="close"></div>
        </div>
      </div>
      <div
        ref="searchResultDom"
        @scroll="calcTop"
        v-show="!showHistory && !showQuestion"
        class="content"
      >
        <template v-for="(item,index) in searchList">
          <div v-if="item.role == 'input'" class="user">
            <p>{{item.content}}</p>
          </div>
          <div v-else-if="item.role == 'search'&&searching" class="agent">
            <p class="search">正在拼命生成中…</p>
          </div>
          <div
            v-else-if="item.role == 'assistant'&& (item.reasoningContent||item.text||item.content)"
            class="result"
          >
            <div class="content">
              <div
                class="content-reasoning"
                v-if="item.reasoningContent&&item.reasoningContent.trim&&item.reasoningContent.trim()"
                v-html="item.reasoningContent.trim()"
              ></div>
              <div class="content-content" v-html="(item.text||item.content||'').trim()"></div>
            </div>
            <div class="btns">
              <div class="l" :class="{hide:index!=searchList.length-1||searching||answering}">
                <div class="star"></div>
                <span @click="recreate(index,item)">重新生成</span>
              </div>
              <div class="r">
                <div
                  @mousedown.stop
                  @click="handleExchange(item.content||item.text)"
                  :class="{exchange: true}"
                ></div>
                <div @click="handleCopy(item.content||item.text)" class="copy"></div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div @click="stop" class="stop hide" v-if="searching||answering">
        <i class="del"></i>
        <span>停止搜索</span>
      </div>
      <div
        v-show="!showHistory && !showQuestion"
        class="foot"
        :class="{searching:searching||answering}"
      >
        <!-- <div class="voice"></div> -->
        <div class="input">
          <textarea
            @keydown="handleInput"
            maxlength="255"
            v-model.trim="searchContent"
            placeholder="在此输入你的问题，shift+enter换行"
            type="text"
          />
          <div @click="search" class="search"></div>
        </div>
        <div @click.stop="stop" class="stop" v-if="searching||answering">
          <i class="del"></i>
          <span>停止搜索</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common';
import * as config from '@common/config';
import store from '@common/store';

import { fetchEventSource } from '@microsoft/fetch-event-source';
import qs from 'qs';

export default {
  // 智能写稿
  name: 'aiWriter',
  data() {
    return {
      scrollInterval: null,
      keyword: '',
      showContent: false,
      feedBackIndex: 0,
      history: {},
      show: false,
      r: null,
      showHistory: false,
      showQuestion: false,
      isSubmit: false,
      configInfo: {},
      searchContent: '',
      pages: {
        pageIndex: 1,
      },
      searchList: [],
      reason_types: [],
      suggestion: '',
      scrollTop: 0,
      noMore: false,
      // 提问，还未有答案时
      searching: false,
      // 正在回答 已经有答案了
      answering: false,
    };
  },
  methods: {
    handleScroll() {
      const container = this.$refs.searchResultDom;
      const atBottom =
        container.scrollHeight - container.scrollTop <= container.clientHeight + 5;
        
      this.userScrolledUp = !atBottom;
      console.log('handleScroll this.userScrolledUp',this.userScrolledUp)
    },
    recreate(index, item) {
      let lastItem = this.searchList[index - 1];

      let prompt = lastItem.content;
      console.log('recreate last', lastItem, prompt);
      // 去掉最后一项 回答项
      this.searchList.splice(index, 1);
      this.searching = true;

      this.searchList.push({
        role: 'search',
      });
      this.scrollToEnd();

      this.askQuestion({ prompt, content: this.content_bg, model: 'DeepSeek' })
        .then((res) => {
          console.log('回答完成', res);
        })
        .catch((err) => {
          console.log('回答 发生错误', err);
        });
    },
    stop() {
      // 如果当前还在搜索 还没生成答案
      if (this.searching) {
        this.ctrlAbout && this.ctrlAbout.abort();
        this.ctrlAbout = null;
        this.searchList.splice(this.searchList.length - 1, 1);
        this.searching = false;
      }
      // 如果正在回答
      if (this.answering) {
        this.ctrlAbout && this.ctrlAbout.abort();
        this.ctrlAbout = null;
        this.answering = false;
      }
    },
    /**
     * 去掉 文本开头br标签
     */
    handleRemoveFirstBR(text) {
      text = text.replace(/^(<br\s*\/?>)+/i, '');
      return text;
    },
    handleCopy(content) {
      console.log('handleCopy', content);

      // 创建一个临时的 textarea 元素
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = content;

      // 将其添加到 DOM 中
      document.body.appendChild(tempTextArea);

      // 选中并复制内容到剪贴板
      tempTextArea.select();
      document.execCommand('copy');

      // 移除临时的 textarea 元素
      document.body.removeChild(tempTextArea);
      this.$toast('复制成功');
      console.log('Content copied to clipboard');
    },
    /**
     * 过滤 只复制 纯文本
     * @param content
     */
    handleCopy2(e) {
      console.log('handleCopy 过滤 ', e);
      // 获取选中的文本
      let selection = window.getSelection().toString();
      console.log('handleCopy 过滤  selection', selection);

      // 如果需要，可以在这里对选中的文本进行处理，比如去除格式、HTML标签等

      // 阻止默认的复制行为
      e.preventDefault();

      // 将处理后的纯文本放入剪贴板
      e.clipboardData.setData('text/plain', selection);
      const text = (e.clipboardData || window.clipboardData).getData('text');
      console.log('最后的 text', text);
    },
    handleExchange(html) {
      console.log('handleExchange', html);
      // console.log('handleExchange', html);
      this.$emit('copy', html);
    },
    // 每次搜索 重新打开一个会话
    initSearch({ queryText, selectionText }) {
      console.log('initSearch(rest)', { queryText, selectionText });
      // 之前如果有提问，需要终止掉
      this.stop();
      this.searchList = [];
      this.searchContent = '';
      this.topSearch({ prompt: queryText, content: selectionText });
    },
    handleInput(event) {
      if (event.key === 'Enter' && event.shiftKey) {
        console.log('Shift + Enter pressed');
        console.log('去 换行');
      } else if (event.key === 'Enter') {
        console.log('去 search');
        event.preventDefault();
        this.search();
      }
    },

    calcTop(e) {
      // console.log(e)
      this.scrollTop = e.target.scrollTop;
      // 是否当前在底部
      const container = this.$refs.searchResultDom;
      const atBottom =
        container.scrollHeight - container.scrollTop <= container.clientHeight + 5;
        
      this.userScrolledUp = !atBottom;
      console.log('userScrolledUp',this.userScrolledUp)
    },
    toggleShowContent(showContent) {
      // if(this.showContent){
      //   this.scrollTop = this.$refs.searchResultDom.scrollHeight
      //   console.log(this.$refs.searchResultDom.scrollHeight)
      // }

      this.showContent = showContent;

      if (this.showContent) {
        this.$nextTick(() => {
          this.$refs.searchResultDom.scrollTop = this.scrollTop;
        });
      }
      // 让外部 取消掉 hightElement 高亮的元素包裹，还原成选区
      else {
        this.stop();
        this.$emit('hide');
      }
    },
    openDetail(detail, title) {
      let data = {
        type: detail.type,
        id: detail.id,
        create: store.state.create,
        canEdit: false,
        quickEdit: store.state.quickEdit,
        keywords: title,
        search_from: 'bubble',
        search_hit: JSON.stringify(detail.search_hit),
        vector_result: detail.vector_result,
      };
      this.$materialBox(data);
    },
    submitFeedback(is_satisfied) {
      let reason_types = [];

      this.configInfo.feedback.forEach((el) => {
        if (el.selected) {
          reason_types.push(el.id);
        }
      });

      let info = {
        is_satisfied: is_satisfied,
        keyword: this.keyword,
        reason_types: reason_types.join(','),
        suggestion: this.suggestion,
      };
      common.myFetch(config.apis.submitFeedback, info).then((r) => {
        if (r) {
          this.configInfo.feedback.forEach((el) => {
            el.selected = false;
          });
          this.suggestion = '';
          if (is_satisfied == 0) {
            this.isSubmit = true;
          }
        }
      });
    },
    topSearch({ prompt, content }) {
      this.content_bg = content;
      this.searchList.push({
        role: 'input',
        content: prompt,
      });
      this.searching = true;
      this.searchList.push({
        role: 'search',
      });
      this.searchContent = '';
      this.scrollToEnd();

      this.askQuestion({ prompt, content, model: 'DeepSeek' });
    },
    scrollToEnd() {
      this.$nextTick(() => {
        this.$refs.searchResultDom.scrollTop = this.$refs.searchResultDom.scrollHeight;
      });
    },
    askQuestion(info) {
      //  根据环境来
      const VUE_APP_Server = location.origin+'/index.php?r=intelligent/webapi/chat-submit-optimize';
      let userKeys = common.userKeys();

      let data = Object.assign(info, userKeys);
      console.log('askQuestion', data);
      this.ctrlAbout = new AbortController();
      return new Promise((resolve, reject) => {
        let eventSourcepost = fetchEventSource(`${VUE_APP_Server}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: qs.stringify(data),
          signal: this.ctrlAbout.signal,
          openWhenHidden: true, //离开页面导致的连接断开可以通过设置 openWhenHidden: true来避免
          onopen(response) {
            console.log('fetchEventSource onopen', response);
          },
          onmessage: (event) => {
            // 最后一项
            let lastItem;
            let conversationLen = this.searchList.length || 0;

            lastItem = this.searchList[conversationLen - 1];

            // 如果是第一次获得答案，去掉上面一条 生成中的气泡
            if (this.searching) {
              let lastInputItem = this.searchList.slice(conversationLen - 2, conversationLen - 1);
              let searingItem = this.searchList.splice(conversationLen - 1, 1);
              console.log('searingItem', searingItem);
              console.log('lastInputItem', lastInputItem);
              this.searching = false;
              this.answering = true;
              // 添加一条答案项
              lastItem = {
                role: 'assistant',
                isLoading: true,
              };
              this.searchList.push(lastItem);
            }

            let { text = '', reasoningContent = '' } = lastItem;

            let { type, value = '' } = JSON.parse((event && event.data) || '{}');
            console.log('type value', type, value);
            // // 如果接收推理过程
            if (type == 'reasoning_content') {
              reasoningContent += value;
            } else if (type == 'done') {
              console.log('onmessage 完毕');
              this.scrollToEnd();
              return;
            } else {
              text += value;
            }

            this.$set(this.searchList, conversationLen - 1, { ...lastItem, text, reasoningContent, isLoading: false });
            console.log('onmessage value',value)
            if(!this.userScrolledUp){
            
              this.scrollToEnd()
            }
            // -------------
            // 成功之后满足某些条件可以使用AbortController关闭连接
            // this.ctrlAbout.abort()
          },
          onerror: (err) => {
            // 服务异常
            console.log(err);
            reject(err);
          },
          onclose: () => {
            this.ctrlAbout && this.ctrlAbout.abort();
            // 服务关闭
            this.ctrlAbout = null;
            this.answering = false;
            console.log('请求完毕 onclose');
            resolve('回答完毕');
          },
        });
      });
    },

    search() {
      let searchContent = this.searchContent;
      if (!this.searchContent) {
        this.$toast('请输入检索关键词');
        return false;
      }
      if (this.searching || this.answering) {
        return;
      }

      this.searchList.push({
        role: 'input',
        content: searchContent,
      });
      this.searching = true;
      this.searchList.push({
        role: 'search',
      });
      this.searchContent = '';
      this.scrollToEnd();

      this.askQuestion({ prompt: searchContent, content: this.content_bg, model: 'DeepSeek' })
        .then((res) => {
          console.log('回答完成', res);
        })
        .catch((err) => {
          console.log('回答 发生错误', err);
        });
    },
    open(c, r) {
      this.r = r;
      this.show = true;
      this.showContent = true;
      this.getConfig();
    },
    close() {
      this.show = false;
    },
    getConfig() {
      common.myFetch(config.apis.indexConfig).then((r) => {
        if (r) {
          r.feedback.forEach((el) => {
            el.selected = false;
          });
          this.configInfo = r;
          console.log('getConfig configInfo', r);
        }
      });
    },
    getViewHistory() {
      common.myFetch(config.apis.viewhistory).then((r) => {
        if (r) {
          console.log('getViewHistory r', r);
        }
      });
    },
    getSearchlog() {
      let info = {
        page: this.pages.pageIndex,
        pagesize: 10,
      };
      common.myFetch(config.apis.searchlog, info).then((r) => {
        if (r) {
          console.log(r);
          if (this.pages.pageIndex == 1) {
            this.history = r;
          } else {
            let list = this.history.sevenDayAgo.list;
            if (r.sevenDayAgo.list.length == 0) {
              this.noMore = true;
            }
            list = list.concat(r.sevenDayAgo.list);
            r.sevenDayAgo.list = list;
            this.history = r;
          }
        }
      });
    },
    async getScroll(e) {
      if (e) {
        if (this.scrollInterval) {
          clearTimeout(this.scrollInterval);
          this.scrollInterval = null;
        }

        this.scrollInterval = setTimeout(() => {
          let containerH = 482;
          let scrollTop = e.target.scrollTop;
          let listHeight = this.$refs.list.offsetHeight;
          console.log('getScroll');
          if (scrollTop + containerH >= listHeight && !this.noMore) {
            this.pages.pageIndex++;
            console.log('getScroll 拿分页');
            this.getSearchlog();
          }
        }, 300);
      }
    },
  },
  mounted() {
    // this.$AiMaterial()
  },
  created() {},
};
</script>

<style lang="less" scoped>
@import '../../assets/css/global.less';
.aiWriter {
  position: fixed;
  z-index: 1000;
  top: 100px;
  right: 0;
  width: 482px;
  bottom: 0;

  .aiWriter-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: url('./assets/bg.png') no-repeat;
    background-position: -14px -6px;
    box-sizing: border-box;

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;

      border-radius: 12px 12px 0px 0px;

      padding: 0 20px;
      box-sizing: border-box;

      .l {
        display: flex;
        align-items: center;

        .icon {
          display: block;
          width: 22px;
          height: 22px;
          background: url('./assets/icon.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 6px;
        }

        .title {
          font-size: 16px;
          color: #050f0f;
          font-weight: bold;
        }
      }

      .r {
        display: flex;
        align-items: center;

        .history {
          width: 20px;
          height: 20px;
          background: url('./assets/history.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
        }

        .close {
          width: 20px;
          height: 20px;
          background: url('./assets/sq.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-left: 10px;
          user-select: none;
          cursor: pointer;
        }
      }
    }

    & > .content {
      flex: 1;
      min-height: 0;
      width: 100%;
      overflow-y: auto;
      padding: 6px 20px 14px;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 4px;
      }

      .tipsContent {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 16px 20px;
        box-sizing: border-box;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.8);
        margin-bottom: 20px;

        .t {
          padding-bottom: 14px;
          box-sizing: border-box;
          font-weight: bold;
          font-size: 16px;
          color: #050f0f;
          line-height: 24px;

          & > span {
            position: relative;

            & > span {
              position: relative;
              z-index: 2;
            }

            &:before {
              display: block;
              content: '';
              position: absolute;
              z-index: 1;
              bottom: 0;
              left: 0;
              width: -webkit-fill-available;
              height: 6px;
              background: #80dabb;
            }
          }
        }

        .b {
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
        }
      }

      .likeContent {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .title {
          font-weight: bold;
          font-size: 16px;
          color: #050f0f;
          line-height: 24px;
          margin-bottom: 10px;
        }

        .likebox {
          width: 100%;
          padding: 14px;
          box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
          box-sizing: border-box;
          background: #fff;

          ul {
            display: flex;
            flex-direction: column;
            width: 100%;

            li {
              display: flex;
              align-items: center;
              width: 100%;
              height: 40px;
              background: #f3f5f7;
              border-radius: 12px;
              margin-bottom: 10px;
              padding: 0 10px;
              box-sizing: border-box;
              user-select: none;
              cursor: pointer;

              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }

              .icon1 {
                width: 20px;
                height: 20px;
                background: url('./assets/icon1.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              .icon2 {
                width: 20px;
                height: 20px;
                background: url('./assets/icon2.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              p {
                flex: 1;
                min-width: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 500;
                font-size: 13px;
                color: #050f0f;
              }
            }
          }
        }
      }

      .user {
        display: flex;
        justify-content: flex-end;

        max-width: 306px;
        margin-left: auto;
        margin-bottom: 20px;
        white-space: pre-wrap;

        p {
          padding: 9px 14px;
          box-sizing: border-box;
          background: #29b785;
          border-radius: 12px 12px 0px 12px;
          font-weight: 500;
          font-size: 13px;
          color: #ffffff;
          line-height: 22px;
          word-break: break-all;
        }
      }

      .agent {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        margin-bottom: 20px;

        p {
          display: flex;
          align-items: center;
          padding: 9px 14px;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 22px;

          &.search {
            &::before {
              display: inline-flex;
              content: '';
              width: 20px;
              height: 20px;
              background: url('./assets/searchIcon.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }
          }
        }
      }

      .fav {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .title {
          font-weight: bold;
          font-size: 16px;
          color: #050f0f;
          line-height: 24px;
          margin-bottom: 10px;
        }

        .fav-list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 68px;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
          padding: 0 14px;
          box-sizing: border-box;

          p {
            display: flex;
            align-items: center;
            width: 160px;
            height: 40px;
            background: #f3f5f7;
            border-radius: 12px;
            border: 1px solid transparent;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 13px;
            color: #050f0f;
            padding: 0 10px;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;

            .origin {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/icon3.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            .full {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/icon2.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            &.on {
              border: 1px solid #41b48c;
              box-sizing: border-box;
            }
          }
        }
      }

      .result {
        margin-bottom: 20px;
        width: 100%;
        padding: 14px 20px;
        box-sizing: border-box;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.8);

        .content {
          width: 100%;
          padding: 10px 0;
          border-bottom: 1px solid #dddfe7;
          box-sizing: border-box;
          &-reasoning {
            color: #8b8b8b;
            white-space: pre-wrap;
            line-height: 26px;
            font-size: 14px;
            margin-bottom: 15px;
            word-break: break-all;
          }
          &-content {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 14px;
            color: #050f0f;
            white-space: pre-wrap;
            word-break: break-all;
          }
        }

        .btns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding-top: 14px;
          box-sizing: border-box;

          .l {
            display: flex;
            align-items: center;
            user-select: none;
            cursor: pointer;
            &.hide {
              visibility: hidden;
              opacity: 0;
            }
            .star {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/star.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            span {
              font-weight: bold;
              font-size: 13px;
              color: #41b48c;
              text-decoration-line: underline;
            }
          }

          .r {
            display: flex;
            align-items: center;

            .exchange {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/exchange.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 14px;
              user-select: none;
              cursor: pointer;

              &:hover {
                width: 20px;
                height: 20px;
                background: url('./assets/exchangeOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }

              &.on {
                width: 20px;
                height: 20px;
                background: url('./assets/zanOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }

            .copy {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/copy.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 14px;
              user-select: none;
              cursor: pointer;

              &:hover {
                width: 20px;
                height: 20px;
                background: url('./assets/copyOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }
          }
        }
      }

      .noSearch {
        display: flex;
        margin: 14px 0 20px;

        i {
          display: block;
          width: 20px;
          height: 20px;
          min-width: 20px;
          background: url('./assets/searchIcon.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 6px;
        }

        p {
          display: flex;
          flex-wrap: wrap;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 22px;

          span {
            color: #41b48c;
            text-decoration: underline;
            user-select: none;
            cursor: pointer;

            &:nth-last-of-type(1) {
              &::after {
                display: none;
              }
            }

            &::after {
              display: inline-flex;
              content: '、';
            }
          }
        }
      }
    }

    .foot {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 140px;
      background: #ffffff;
      border-radius: 0px 0px 12px 12px;
      padding: 0 10px 0 14px;
      box-sizing: border-box;
      &.searching {
        margin-top: 30px;
      }
      .voice {
        width: 28px;
        height: 28px;
        background: url('./assets/voice.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 14px;
        user-select: none;
        cursor: pointer;
      }

      .input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        min-width: 0;
        height: 100px;
        border-radius: 12px;
        background: #f6f8fb;
        padding: 14px;
        box-sizing: border-box;

        textarea {
          flex: 1;
          min-width: 0;
          height: 100%;
          background: transparent;
          resize: none;

          &::placeholder {
            color: #b9c3c3;
          }
        }

        .search {
          width: 28px;
          height: 28px;
          background: url('./assets/search.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
          margin-left: 10px;
          align-self: flex-end;
        }
      }

      .current {
        position: absolute;
        z-index: 9;
        right: 20px;
        top: -44px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 72px;
        height: 30px;
        background: rgba(231, 232, 233, 1);
        border-radius: 8px;
        user-select: none;
        cursor: pointer;
        font-weight: 500;
        font-size: 13px;
        line-height: 30px;
        color: #050f0f;
      }
    }

    .historyContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 14px 20px 0 20px;
      box-sizing: border-box;

      & > .title {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #050f0f;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 10px;

        .back {
          width: 16px;
          height: 16px;
          background: url('./assets/back.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
          margin-right: 16px;
        }
      }

      & > .content {
        flex: 1;
        min-height: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        padding: 14px 14px 0 14px;
        box-sizing: border-box;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 4px;
        }

        .title {
          padding: 0 6px 0px 6px;
          box-sizing: border-box;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
          margin-bottom: 11px;

          p {
            padding-bottom: 14px;
            border-bottom: 1px solid #dddfe7;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 13px;
            color: #050f0f;
            line-height: 21px;
          }
        }

        & > ul {
          display: flex;
          flex-direction: column;
          width: 100%;

          & > li {
            display: flex;
            flex-direction: column;
            margin-bottom: 12px;

            & > p {
              font-weight: 500;
              font-size: 13px;
              color: #050f0f;
              line-height: 21px;
              margin-bottom: 12px;
            }

            ul {
              display: flex;
              flex-direction: column;
              width: 100%;

              li {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                width: 100%;
                height: 40px;
                background: #f3f5f7;
                border-radius: 12px;
                margin-bottom: 10px;
                padding: 0 12px;
                box-sizing: border-box;
                font-weight: 500;
                font-size: 13px;
                color: #050f0f;
                user-select: none;
                cursor: pointer;

                p {
                  flex: 1;
                  min-width: 0;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                i {
                  display: inline-flex;
                  content: '';
                  width: 8px;
                  height: 8px;
                  background: #41b48c;
                  border-radius: 50%;
                  margin-right: 12px;
                }

                &:nth-last-of-type(1) {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }

    .questionContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 14px 20px 0 20px;
      box-sizing: border-box;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #050f0f;
        line-height: 24px;
        margin-bottom: 10px;
      }

      .content {
        width: 100%;
        height: 432px;
        background: #ffffff;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        padding: 14px 14px 24px;
        box-sizing: border-box;

        .questionBtns {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          border-bottom: 1px solid #dddfe7;
          box-sizing: border-box;

          li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 161px;
            height: 40px;
            background: #f3f5f7;
            border-radius: 12px;
            margin-bottom: 10px;
            font-weight: 500;
            font-size: 13px;
            color: #050f0f;
            border: 1px solid transparent;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;

            &.on {
              border: 1px solid #41b48c;
              box-sizing: border-box;
            }
          }
        }

        .questionTextarea {
          width: 100%;
          flex: 1;
          min-height: 0;
          padding-top: 9px;
          box-sizing: border-box;

          .t {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            i {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/icon4.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 4px;
            }

            span {
              font-weight: 500;
              font-size: 13px;
              color: #050f0f;
              line-height: 21px;
            }
          }

          textarea {
            width: 100%;
            height: 148px;
            background: #f6f8fb;
            border-radius: 12px;
            resize: none;
            padding: 14px 20px;
            box-sizing: border-box;
            margin-bottom: 24px;

            &::placeholder {
              font-size: 14px;
              line-height: 21px;
              color: #b9c3c3;
            }
          }

          .btns {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;

            .btn {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 120px;
              height: 32px;
              background: #b9c3c3;
              border-radius: 4px;
              font-size: 14px;
              color: #ffffff;
              font-weight: bold;
              user-select: none;
              cursor: pointer;

              &.on {
                background: #41b48c;
                margin-right: 20px;
              }
            }
          }
        }
      }
    }

    .fallbackContent {
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 432px;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;

        img {
          width: 64px;
          height: 64px;
          margin-top: 60px;
          margin-bottom: 20px;
        }

        p {
          position: relative;

          span {
            position: relative;
            font-weight: bold;
            font-size: 16px;
            color: #050f0f;
            line-height: 24px;
            z-index: 2;
          }

          &::before {
            display: block;
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 1;
            width: 100px;
            height: 6px;
            background: #80dabb;
          }
        }

        & > span {
          width: 235px;
          text-align: center;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
          margin-top: 14px;
          margin-bottom: 66px;
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 188px;
          height: 32px;
          background: #41b48c;
          border-radius: 4px;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }
}
.stop {
  position: absolute;
  z-index: 9;
  left: 20px;
  top: -44px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 92px;
  height: 30px;
  background: rgba(249, 231, 232, 1);
  border-radius: 8px;
  user-select: none;
  cursor: pointer;
  &.hide {
    visibility: hidden;
    opacity: 0;
    position: relative;
    z-index: -111;
  }
  .del {
    display: block;
    width: 14px;
    height: 14px;
    background: url('./assets/del.png') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    margin-right: 6px;
  }

  span {
    font-weight: 500;
    font-size: 13px;
    line-height: 30px;
    color: #050f0f;
  }
}

@keyframes translateXShow {
  0% {
    transform: translateX(350px);
  }

  100% {
    transform: translateX(10px);
  }
}
</style>

<style lang="less">
.aiWriter {
  em {
    color: #41b48c;
    font-style: normal;
  }
}

@keyframes translateXShow {
  0% {
    transform: translateX(350px);
  }

  100% {
    transform: translateX(10px);
  }
}
</style>
